import {invoke} from "@hybird/core/bridge/hybirdBridge";
import {BridgeMethod} from "@hybird/core/bridge/core";

export class FlutterSteppingMotor extends BridgeMethod {
  /**
   * 执行电机
   * @param status true: 伸出  false: 回收
   * @return {Promise<Object>}
   */
  steppingMotorStart(status) {
    return invoke("steppingMotorStart", {
      params: {
        status
      }
    });
  }

  /**
   * 点击停止
   * @return {Promise<Object>}
   */
  steppingMotorStop() {
    return invoke("steppingMotorStop");
  }
}

export const flutterSteppingMotor = new FlutterSteppingMotor();